var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as Long from "long";
import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { selectCoopLevels } from "../../balancingSelectors/selectBalancingXpLevels";
import { IdOrientation } from "../../constants/IdOrientation";
import { IdStyles } from "../../less/IdStyles";
import { selectCoopSearchSelectedCoop, selectCoopXp, selectCurrentCoopLevel, } from "../../selectors/selectCoopInfo";
import { selectEventEndTime, selectRunningCoopProjectEventInfo, } from "../../selectors/selectEventInfo";
import { selectCurrentTabId } from "../../selectors/selectModalTabId";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { ReplacementLoca } from "../../utils/i18n/ReplacementLoca";
import { utilTime } from "../../utils/utilTime";
import { ButtonSecondarySquareSmall } from "../generic/common/ButtonSecondarySquareSmall";
import { IconWithProgress } from "../generic/icon-with-progress/IconWithProgress";
import { Icon } from "../generic/icon/Icon";
import { IdIcon } from "../generic/icon/IdIcon";
import { NumberFormat } from "../generic/number-format/NumberFormat";
import { TimeRemaining } from "../time/TimeRemaining";
import { TooltipText } from "../tooltip";
import { actionCoopClearSelectedCoop } from "./actionCoop";
import { IdCoopCategory } from "./IdCoopCategory";
var MenuCoopFooterDOM = /** @class */ (function (_super) {
    __extends(MenuCoopFooterDOM, _super);
    function MenuCoopFooterDOM() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getCoopSearchFooterDom = function () {
            var clearSelectedCoop = _this.props.clearSelectedCoop;
            return (React.createElement("div", { className: "coop-search-back-btn mouse-hover", onClick: clearSelectedCoop },
                React.createElement(ButtonSecondarySquareSmall, null),
                React.createElement(Icon, { styleId: "coop-search-back-btn-icn " + IdStyles.IconSmall, icon: IdIcon.GreenArrowIcn, orientation: IdOrientation.Down })));
        };
        _this.getCoopProjectsFooterDom = function () {
            var coopProjectEventTimer = _this.getCoopProjectEventTimer();
            var coopXpProgress = _this.getCoopXpProgress();
            return (React.createElement("div", { className: "flex flex--spaced w100" },
                coopProjectEventTimer,
                coopXpProgress));
        };
        _this.getCoopProjectEventTimer = function () {
            var runningCoopProjectEvent = _this.props.runningCoopProjectEvent;
            var endTime = runningCoopProjectEvent
                ? selectEventEndTime(runningCoopProjectEvent.proto)
                : undefined;
            var seconds = utilTime.secondsLeftTill(endTime);
            var roundedSeconds = Math.round(seconds);
            var replacements = new Map([[ReplacementLoca.zero_0, utilTime.format(roundedSeconds)]]);
            return runningCoopProjectEvent && endTime ? (React.createElement(TooltipText, { id: IdLoca.tooltip_coopProjects_eventTime, replacements: replacements },
                React.createElement("div", { className: "flex" },
                    React.createElement(TimeRemaining, { remainingTime: endTime })))) : (undefined);
        };
        _this.getCoopXpProgress = function () {
            var _a = _this.props, currentCoopLevel = _a.currentCoopLevel, coopXp = _a.coopXp;
            var coopLevels = selectCoopLevels();
            var currentLevelInfo = coopLevels.get(currentCoopLevel);
            var nextLevelInfo = coopLevels.get(currentCoopLevel + 1);
            var progress = Long.fromInt(100);
            var xpToNextLevel = Long.ZERO;
            var currentLevelXp = currentLevelInfo && currentLevelInfo.requiredCoopXp
                ? currentLevelInfo.requiredCoopXp
                : 0;
            var nextStageXp = nextLevelInfo && nextLevelInfo.requiredCoopXp ? nextLevelInfo.requiredCoopXp : 0;
            if (nextStageXp > 0) {
                progress = coopXp
                    .subtract(currentLevelXp)
                    .multiply(100)
                    .divide(nextStageXp - currentLevelXp);
                xpToNextLevel = Long.fromValue(nextStageXp).subtract(coopXp);
            }
            var locaReplacements = new Map([[ReplacementLoca.zero_0, xpToNextLevel.toString(10)]]);
            var iconText = (React.createElement(NumberFormat, { amount: currentCoopLevel, className: IdStyles.TextBoldSecondaryOutline }));
            return (React.createElement("div", { className: "flex flex--guts flex__full" },
                React.createElement(TooltipText, { id: IdLoca.floatingText_coopXplevelup, replacements: locaReplacements },
                    React.createElement(IconWithProgress, { progressPercent: progress.toNumber(), fillClassName: IdStyles.ProgressBarFill, backgroundClassName: IdStyles.ProgressBarBackground, icon: IdIcon.CoopXpIcn, iconStyle: IdStyles.IconLarge, iconTextComponent: iconText },
                        React.createElement(NumberFormat, { className: IdStyles.TextBoldSecondaryOutline, amount: coopXp })))));
        };
        return _this;
    }
    MenuCoopFooterDOM.prototype.render = function () {
        var _a = this.props, selectedTabId = _a.selectedTabId, selectedCoop = _a.selectedCoop;
        var footerDOM = React.createElement(React.Fragment, null);
        if (selectedTabId === IdCoopCategory.CoopSearch && selectedCoop) {
            footerDOM = this.getCoopSearchFooterDom();
        }
        else if (selectedTabId === IdCoopCategory.CoopProjects) {
            footerDOM = this.getCoopProjectsFooterDom();
        }
        return footerDOM;
    };
    return MenuCoopFooterDOM;
}(React.Component));
var mapState = function (state) {
    return {
        coopXp: selectCoopXp(state),
        currentCoopLevel: selectCurrentCoopLevel(state),
        runningCoopProjectEvent: selectRunningCoopProjectEventInfo(state),
        selectedCoop: selectCoopSearchSelectedCoop(state),
        selectedTabId: selectCurrentTabId(state),
    };
};
var mapDispatch = function (dispatch) {
    return bindActionCreators({
        clearSelectedCoop: function () { return actionCoopClearSelectedCoop(); },
    }, dispatch);
};
export var MenuCoopFooter = connect(mapState, mapDispatch)(MenuCoopFooterDOM);



//////////////////
// WEBPACK FOOTER
// ./src/features/cooperative/MenuCoopFooter.tsx
// module id = 2809
// module chunks = 3